export const SET_USERINFO = 'SET_USERINFO'
export const SET_SHARECONFIG = 'SET_SHARECONFIG'
export const SET_FOLLOWCONFIG = 'SET_FOLLOWCONFIG'
export const SET_WXCONFIG = 'SET_WXCONFIG'
export const INIT_BASE_DATA = 'INIT_BASE_DATA'
export const SET_VIP_CONFIG = "SET_VIP_CONFIG"


// WEBPACK FOOTER //
// ./src/store/mutations-types.js